export default "/_next/static/fonts/DancingScript.5e15416c2d596d51a588d1d158b3a421.ttf";